<template>
  <div class="tool" :style="{ '--base-color': $theme.basecolor, '--base-fore': $theme.basefore }">
    <div class="toolbar-header" style="min-height: 16px">
      <!-- <div v-if="language" class="lang-select-wrapper"> -->
      <cyb-select v-model="language" :options="options" tabindex="1" select-style="border-width: 0 1px 0 1px;" flag @input="getLabels(language.code)" />
      <!-- <select v-model="language" @change="getLabels(language.code)">
          <option v-for="lang in options" :key="lang.code" :value="lang">
            {{ lang.label }}
          </option>
        </select>
        <flag class="flag" :squared="false" :iso="language.flag" /> -->
      <!-- </div> -->
    </div>
    <div class="toolbar toolbar-wrapper" style="min-height: 80px">
      <div class="toolbar-item logo-wrapper">
        <div v-if="$hotel.logo"><img :src="$hotel.logo" :alt="`Hotel logo (${$hotel.logo})`" class="hotel-logo" @click="reset" /></div>
        <h3 v-else-if="$hotel.titolo" class="hotel-title">{{ $hotel.titolo }}</h3>
      </div>
      <div class="toolbar-item hotel-wrapper">
        <h3 v-if="$hotel.riga1" class="hotel-title">{{ $hotel.riga1 }}</h3>
        <a v-if="$hotel.riga2" tabindex="2" class="hotel-address" :href="'https://www.google.com/maps/search/' + $hotel.riga2">
          {{ $hotel.riga2 }}
          <fa :icon="['fas', 'map-marker-alt']" />
        </a>
        <a v-if="$hotel.riga3" tabindex="3" :href="'mailto:' + $hotel.riga3">
          {{ $hotel.riga3 }}
          <fa :icon="['fas', 'envelope']" />
        </a>
        {{ $hotel.riga4 }}
        <a v-if="$hotel.telefono" :href="'tel:' + $hotel.telefono.replace(/[^0-9+]/g, '')">
          {{ $hotel.telefono }}
          <fa :icon="['fas', 'phone']" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from "../services/api";
import CybSelect from "../components/cybselect.vue";

export default {
  name: "CybToolBar",
  components: {
    CybSelect
  },
  data() {
    return {
      language: {},
      // vengono caricate dal DB
      options: [
        { label: "Italiano", flag: "it", code: "ITA", icon: "it" },
        { label: "Inglese", flag: "gb", code: "ENG", icon: "gb" },
        { label: "Francese", flag: "fr", code: "FRA", icon: "fr" },
        { label: "Tedesco", flag: "de", code: "TED", icon: "de" }
      ],
      labels: {}
    };
  },
  mounted() {
    this.$root.$on("lang:request", (lingua) => {
      this.getLabels(lingua);
    });
  },
  methods: {
    reset() {
      if (this.$store.form) {
        this.$store.form = null;
        this.$router.push("/?RPC_db=" + this.$store.db + "&idhotel=" + this.$store.idhotel + "&lan=" + this.$store.lang);
      }
    },
    getLabels(lang = "ita") {
      apiService.get("BE_booking/lingue/" + this.$store.db + "/" + this.$store.idhotel + "/" + lang).then((resp) => {
        this.$root.$emit("lang:change", resp.labels);
        this.$store.lang = resp.lingua;
        this.$store.idlang = resp.idlingua;
        this.$store.descsottototali = resp.descsottototali;

        // label toolbar
        this.labels = resp.labels;
        if (this.labels.lingue) {
          this.options = [];
          for (let i = 0; i < this.labels.lingue.length; i++) {
            this.options[i] = {
              id: this.labels.lingue[i].codice,
              label: this.labels.lingue[i].label,
              flag: this.codeFlag(this.labels.lingue[i].codice),
              code: this.labels.lingue[i].codice,
              icon: this.codeFlag(this.labels.lingue[i].codice)
            };
          }
        }

        // selettore (get)
        var preselected = this.options.find((item) => item.code === lang.toUpperCase() || item.flag === lang);
        if (preselected) {
          this.language = preselected;
        }
        if (this.$store.lang && this.$store.idlang) {
          this.$root.$emit("rooms:reload");
          this.$root.$emit("services:reload");
          this.$root.$emit("form:reload");
          this.$root.$emit("thanks:reload");
          this.$root.$emit("webcheckin:reload");
        }
      });
    },
    codeFlag(code) {
      switch (code.toUpperCase()) {
        case "ITA":
          return "it";
        case "ENG":
        case "ING":
          return "gb";
        case "FRA":
          return "fr";
        case "TED":
          return "de";
      }
    }
  }
};
</script>

<style lang="scss">
@media (max-width: 400px) {
  .toolbar-header,
  .toolbar {
    left: 0;
    right: 0;
    padding: 0 2% !important;
  }
}
@media (max-width: 1200px) {
  .toolbar-header {
    .row {
      width: 92%;
    }
  }
}
.tool {
  z-index: 99;
  position: sticky;
  top: 0;
}
.toolbar-header,
.toolbar {
  left: 0;
  right: 0;
  padding: 0 6.2%;
}
.toolbar-header {
  position: relative;
  font-size: 0.7em;
  background: #ffffffdb;
  backdrop-filter: blur(6px);
  display: flex;
  flex-direction: row-reverse;
  padding: 0 calc(5.6% + 7px);
  width: 100%;
  z-index: 99;
  select {
    border: none;
    background-color: transparent;
    outline: none;
    cursor: pointer;
    &:active {
      outline: none;
    }
  }
}
.toolbar {
  margin: 0;
  position: absolute;
  max-height: 6em;
  width: 100%;
  background-color: #ffffff5c;
  backdrop-filter: blur(6px);
  // opacity: 0.8;
  text-align: left;
  &.toolbar-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .toolbar-item {
      display: flex;
      flex-direction: column;
      &.logo-wrapper {
        text-align: right;
        min-width: 130px;
        align-items: left;
        justify-content: center;
        .hotel-logo {
          height: 5rem;
        }
        // nome del ristorante al posto del logo
        .hotel-title {
          font-size: 1.8em;
          text-align: left;
        }
      }
      &.hotel-wrapper {
        align-items: right;
        text-align: right;
        font-size: 0.8em;
        .hotel-title {
          font-size: 2.2em;
        }
        a {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 1ch;
          color: inherit;
          &:hover {
            color: var(--base-color);
          }
        }
      }
    }
  }

  h3 {
    margin: 0;
    padding: 0;
  }
}
</style>
